import { render, staticRenderFns } from "./DeliveryPolicy.vue?vue&type=template&id=5660c3f9&"
import script from "./DeliveryPolicy.vue?vue&type=script&lang=js&"
export * from "./DeliveryPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports